import { createLoadableList } from 'external/immutability-helper'

import create, {initializeAndRegisterHooks} from 'context/create' 
import triggers, * as resolves from './triggers'

const id = 'Payment'

export const initialState = {
    cart: {
        id: localStorage.getItem('cartId'),
        client: undefined,
        properties: {},
    },
    offersSummaryList: createLoadableList()
}


const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, triggers, resolves)})
export {context as default}